'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeToReducer;

var _typeToReducer2 = require('type-to-reducer');

var _typeToReducer3 = _interopRequireDefault(_typeToReducer2);

var _types = require('./types');

var _types2 = require('shared/components/MatchTooltip/types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CATEGORIES = [{
  id: 'skills',
  label: 'My Skills'
}, {
  id: 'interests',
  label: 'My Interests'
}, {
  id: 'education',
  label: 'My Education'
}, {
  id: 'matches',
  label: 'My Job Matches'
}];

var SECTION_LABELS = {
  interests: 'Tell us what interests you in your life and on the job',
  skills: 'Select the skills you have.\n  To find jobs that might be great for you in the future,\n  also select the skills you plan to acquire.',
  education: 'Select the highest level of education you have completed.\n  To find jobs that might be great for you in the future, select the level of\n  education you plan to complete.',
  matches: 'These jobs best match the interests, skills, and education you shared.\n  You can explore any of them to learn more, or check out how you match to more jobs\n  in Financial Services'
};

var initialState = {
  currentCategory: 'skills',
  categories: CATEGORIES,
  sectionLabels: SECTION_LABELS,
  visible: false
};

var getCategory = function getCategory(category, currentCategory) {
  if (category) {
    return category;
  }

  var index = CATEGORIES.map(function (c) {
    return c.id;
  }).indexOf(currentCategory);
  return CATEGORIES[index + 1].id;
};

var shouldBeVisible = function shouldBeVisible(shouldOpen, state) {
  if (shouldOpen === undefined) {
    return !state.visible;
  }

  return shouldOpen;
};

exports.default = (0, _typeToReducer3.default)((_typeToReducer = {}, (0, _defineProperty3.default)(_typeToReducer, _types.CHANGE_CATEGORY, function (state, _ref) {
  var category = _ref.category;

  return (0, _extends3.default)({}, state, {
    currentCategory: getCategory(category, state.currentCategory)
  });
}), (0, _defineProperty3.default)(_typeToReducer, _types2.MATCH_ME, function (state, _ref2) {
  var shouldOpen = _ref2.shouldOpen;

  return (0, _extends3.default)({}, state, {
    visible: shouldBeVisible(shouldOpen, state)
  });
}), _typeToReducer), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Matcher/reducer.js
// module id = 445
// module chunks = 0